export default __webpack_public_path__ + "static/media/blueTransparentEye.71828893.svg";